import {FeatureConfig} from '@/utils/constants/featuresFlag'

export const BASE_URL_PLACEHOLDER = {
  ADMIN_PORTAL: `{{${FeatureConfig.apiAdminUrl}}}`,
  EVENTS: `{{${FeatureConfig.apiEventsUrl}}}`,
}

/**
 * @deprecated Use the new API endpoints defined in the API_CONFIG object.
 */
export const ENDPOINTS = {

  // MARK: - Admin-Portal Endpoints
  LOAD_USER_ROLES: `${BASE_URL_PLACEHOLDER.ADMIN_PORTAL}/v1/users/auth/cct`,

  // master tables
  LOAD_COUNTRIES: '/countries',
  LOAD_LANGUAGES: '/languages',
}
